import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/people.png'


const _withScopeId = n => (_pushScopeId("data-v-7791e3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_publish" }
const _hoisted_2 = { class: "list flex-1" }
const _hoisted_3 = { class: "info-ctn flex-column" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "after" }, null, -1))
const _hoisted_7 = { class: "people" }
const _hoisted_8 = {
  class: "touxiang",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "imgel",
  fit: "cover",
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = { class: "has" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "van_i" }
const _hoisted_17 = { class: "zan" }
const _hoisted_18 = { class: "t_l" }

import { ref } from "vue"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { showSuccessToast, showFailToast, showLoadingToast, closeToast, showNotify, showConfirmDialog } from "vant"
import { getUserProjectRequireApi } from "@/api/my" // 接口
import { addFeedBackApi } from "@/api/home"
import DataList from "@/api/common"
import {
  removeUserProjectRequireApi,
  takeUpUserProjectRequireApi,
  takeDownUserProjectRequireApi
} from "@/api/projectDemand" //接口

export default /*#__PURE__*/_defineComponent({
  __name: 'publishList',
  setup(__props) {

const listRef: any = ref(null)
const list: any = ref([])
const route = useRoute()
const params: any = ref({})
const item: any = ref()
const showPopover = ref(new Array(list.value.length).fill(false))
const actions = [{ text: "下架" }, { text: "删除" }]
const actions2 = [{ text: "上架" }, { text: "删除" }, { text: "编辑" }]
const gotoDetail = (item: any) => {
  console.log(item)
  //记录浏览量
  var datas = {
    originalSfid: item.sfid,
    type: "project"
  }
  addFeedBackApi(datas).then(() => {})
  router.push({ path: "/projectDemand/detail", query: { id: item.sfid, status: item.zt } })
}
const getItem = (value: any) => {
  item.value = value
}
const onSelect = (e: any, index: number) => {
  console.log(e)
  console.log(index)
  onShowConfirmDialog(e?.text, index)
  //   switch (index) {
  //     case 0:
  //       break
  //     case 1:
  //       formatOneDecimal(row, key)
  //       break
  //     case 2:
  //       formatTowDecimal(row, key)
  //       break
  //   }
}
const onShowConfirmDialog = (text: any, index: number) => {
  if (text == "编辑") {
    // 跳转编辑页面
    router.push({ path: "/projectDemand/publishDemand", query: { id: item.value?.sfid } })
  } else {
    let newUrl: any
    if (text == "下架") {
      newUrl = takeDownUserProjectRequireApi
    } else if (text == "上架") {
      newUrl = takeUpUserProjectRequireApi
    } else {
      newUrl = removeUserProjectRequireApi
    }
    showConfirmDialog({
      // title: text + "确认",
      message: "确认" + text
    }).then(() => {
      showLoadingToast({
        message: "提交中"
      })
      console.log(item.value)
      newUrl(item.value?.sfid).then((res: any) => {
        if (res.code == 200) {
          closeToast()
          var texts: any = text + "成功"
          showNotify({ type: "success", message: texts })
          // 刷新页面
          listRef.value.onRefresh()
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    })
  }
}
// 获取头像
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}

return (_ctx: any,_cache: any) => {
  const _component_van_popover = _resolveComponent("van-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListWithRefreshAndLazyLoad, {
        ref_key: "listRef",
        ref: listRef,
        list: list.value,
        "onUpdate:list": _cache[0] || (_cache[0] = ($event: any) => ((list).value = $event)),
        params: params.value,
        getDataAPI: _unref(getUserProjectRequireApi),
        offset: 20,
        noDataText: "暂无发布记录，快去发布吧~"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-item flex-row",
              key: i
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (item.xqlx)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(item.xqlx == '0' ? 'want' : 'has')
                      }, _toDisplayString(item.xqlx == "0" ? "要" : "有"), 3))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: "tit van-ellipsis",
                    onClick: ($event: any) => (gotoDetail(item))
                  }, _toDisplayString(item.xqbt), 9, _hoisted_5),
                  _createVNode(_component_van_popover, {
                    actions: item.zt === 'off-shelf' ? actions2 : actions,
                    placement: "bottom-end",
                    show: showPopover.value[i],
                    "onUpdate:show": ($event: any) => ((showPopover.value[i]) = $event),
                    onOpen: ($event: any) => (getItem(item)),
                    onSelect: onSelect
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["actions", "show", "onUpdate:show", "onOpen"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    (item.headResourceDetail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "imgel",
                          fit: "cover",
                          src: getImg(item.headResourceDetail?.sfid),
                          alt: ""
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10))
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.userName), 1),
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.zylx), 1)
                ]),
                _createElementVNode("p", {
                  class: "del",
                  onClick: ($event: any) => (gotoDetail(item))
                }, _toDisplayString(item.xqms), 9, _hoisted_14),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(item.shelfTime) + " ", 1),
                    _createElementVNode("i", _hoisted_16, _toDisplayString(item.zt == "off-shelf"
                      ? "已下架"
                      : item.zt == "on-shelf"
                      ? "已上架"
                      : item.isDelete == "1"
                      ? "已删除"
                      : ""), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("i", _hoisted_17, _toDisplayString(item.dzs > 99 ? "99+" : item.dzs), 1),
                    _createElementVNode("i", _hoisted_18, _toDisplayString(item.pls > 99 ? "99+" : item.pls), 1)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "params", "getDataAPI"])
    ])
  ]))
}
}

})